import { Component, OnInit } from '@angular/core';
import { ThemeService } from './services/theme/theme.service';

@Component({
  // eslint-disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet><ng-progress></ng-progress>'
})
export class AppComponent implements OnInit {
  constructor(private theme: ThemeService) {}

  ngOnInit() {
    this.theme.init();
  }
}
